import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CoreDisableNavItems {
  private itemDisabled = new BehaviorSubject<boolean>(false);
  data$ = this.itemDisabled.asObservable();

  setData(data: boolean): void {
    this.itemDisabled.next(data);
  }
}
